<div bpTooltip="Paywith">
	<bp-img class="square" url="assets/paywith-logo.png" [size]="size === 'sm' ? 20 : 25"></bp-img>
</div>
